"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var QuickAccess = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "m16.985 4.377.014.088L17.322 9H21.5a.5.5 0 0 1 .353.854l-.068.057-4.191 2.9.405 5.653a.5.5 0 0 1-.81.428l-.063-.06-3.135-3.526-5.206 3.605c-.414.286-.923-.144-.756-.582l.037-.077 3.343-5.852-2.283-2.568a.5.5 0 0 1 .29-.826L9.5 9h3.851l2.715-4.748c.23-.403.818-.297.92.124Zm-.865 1.795L13.931 10l-3.32-.003 2.023 2.275-2.61 4.563 4.126-2.856 2.746 3.093-.34-4.758L19.903 10h-3.512l-.271-3.828ZM8 13v1H3v-1h5Zm0-4v1H2V9h6Zm5-4v1H5V5h8Z" })));
};
QuickAccess.displayName = 'QuickAccess';
exports.default = QuickAccess;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=QuickAccess.js.map